/**
 * Common error messages for income-related services
 * Centralized to avoid duplication and ensure consistency
 */

export const INCOME_ERROR_MESSAGES = {
  // Generic service errors
  NO_RESPONSE: 'No response received from server',
  NO_DATA: 'No income data received from server',
  NO_HISTORY: 'No income history received from server',
  NO_FILE_DATA: 'No file data received from server',

  // Service-specific errors
  INCOME_CLARITY_FAILED: 'Income clarity request was not successful',
  INCOME_HISTORY_FAILED: 'Income history request was not successful',
  TRIGGER_FAILED: 'Income calculation trigger was not successful',

  // 404 handling - treated as empty state, not an error
  INCOME_CLARITY_NOT_FOUND:
    'Income clarity data not yet available - returning empty state',

  // 400 Error specific messages (now handled by showing actual API error messages)
  EXTRACTION_INCOMPLETE:
    'Income calculation cannot be triggered yet. Please complete all open Income Clarity tasks first.',
  VALIDATION_ERROR:
    'Invalid request data. Please check the loan information and try again.',
  ALREADY_IN_PROGRESS:
    'Income calculation is already in progress. Please wait for it to complete.',
  GENERIC_400_ERROR: 'Invalid request. Please check your data and try again.',

  // File download errors
  FILE_DOWNLOAD_FAILED: 'Failed to download file. Please try again.',
} as const;

// Error patterns are no longer used - we show the actual API error messages
export const INCOME_ERROR_PATTERNS = {
  EXTRACTION_TASKS: 'open income clarity tasks',
  VALIDATION: 'validation',
  ALREADY_IN_PROGRESS: 'already in progress',
} as const;
